import axios from "axios";

const getNotifications = async (page = 1) => {
    return await axios.get(`/notifications?page=${page}`);
}

const getUnreadNotificationsCount = async () => {
    return await axios.get(`/notifications/unread`);
}
const markAsRead = async (notificationId) => {
    return await axios.post(`/notifications/mark-as-read/${notificationId}`);
}
const markAllAsRead = async () => {
    return await axios.post(`/notifications/mark-as-read/all`);
}
export default {   
    getNotifications,
    markAsRead,
    markAllAsRead,
    getUnreadNotificationsCount
};